export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Forensic Science Educator — London, United Kingdom',
    'My students finally understand the difference between evidence types, fingerprints, DNA analysis, and case reconstruction. I used to waste hours searching for the right way to explain how forensic science actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Criminal Justice Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain crime scene investigation, toxicology, digital forensics, or how to teach critical thinking in forensic contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Forensic Science and Investigation Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated forensic science projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Forensic Science Educator | London, United Kingdom',
    "The material on DNA evidence and biological analysis completely changed how my students understand forensic biology. They finally grasp how DNA profiles are created and interpreted. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Criminal Justice Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Forensic Science Teacher | Berlin, Germany',
    "The 50 forensic science projects transformed how my students see real-world applications. Now they investigate crime scenes, analyze evidence, understand case reconstruction, and grasp why forensic knowledge matters professionally and in the justice system. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The forensic science terminology handbook gave me back my class time. I used to spend time explaining forensic concepts and misconceptions. Now I show the handbook and students instantly understand forensic science concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Forensic Science Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real forensic challenges, evaluating evidence reliability, exploring alternative explanations, and understanding how forensic analysis contributes to justice. This completely transformed how they see forensic science.",
  ],
];
